import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import WeeklyTaskForm from './WeeklyTaskForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditWeeklyTaskScreen() {
  const { weekNumber, weekId, id } = useParams();

  const api = Api.WeeklyTask.useReadItem(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Weekly Task"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/weekly-tasks`,
            },
          ]}
        />
        <WeeklyTaskForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
